import { createSlice } from '@reduxjs/toolkit'
import { setAutoFreeze } from 'immer'

setAutoFreeze(false)

const INITIAL_STATE = {
  brandingData: {},
  whiteLabelData: {},
}

const brandingSlice = createSlice({
  name: 'branding',
  initialState: INITIAL_STATE,
  reducers: {
    setBrandingData(state, action) {
      state.brandingData = action.payload
    },
    setWhiteLabelData(state, action) {
      state.whiteLabelData = action.payload
    },
    resetBranding() {
      return INITIAL_STATE
    },
    resetReducer() {
      return INITIAL_STATE
    },
  },
})

export const { setBrandingData, setWhiteLabelData, resetBranding, resetReducer } = brandingSlice.actions
export default brandingSlice.reducer
